import { number, object } from "yup";

export interface ClinicUsageResource {
  usage: number;
}

export const clinicUsageResourceSchema = object({
  usage: number().required(),
});

export const clinicUsageApiResponseSchema = object({
  data: clinicUsageResourceSchema.required(),
});
